import { useApiQuery } from "../services/react-query";

export const useGetNotificationLog = (params) => {
  return useApiQuery({
    queryOptions: {
      queryKey: ["notificationLog", params],
      enabled: !!params.eventId,
    },
    fetchOptions: {
      url: "/notifications/log",
      method: "GET",
      params,
    },
  });
};

export const useGetNotificationReads = (params) => {
  return useApiQuery({
    queryOptions: {
      queryKey: ["notificationLog", "reads", params],
      enabled: !!params.eventId && !!params.id,
    },
    fetchOptions: {
      url: "/notifications/log/reads",
      method: "GET",
      params,
    },
  });
};
